const isPreferredReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
export {
  isPreferredReducedMotion
};
//# sourceMappingURL=isPreferredReducedMotion.js.map
